interface ChatResultTableProps {
  rows: Record<string, unknown>[] | null;
}

function formatCell(v: unknown): string {
  if (v === null || v === undefined) return "—";
  if (typeof v === "object") return JSON.stringify(v);
  return String(v);
}

export function ChatResultTable({ rows }: ChatResultTableProps) {
  if (!rows || rows.length === 0) return null;
  const columns = Object.keys(rows[0]);
  const displayRows = rows.slice(0, 100);
  return (
    <div className="overflow-auto border rounded-md my-2 max-h-96">
      <table className="text-sm w-full">
        <thead className="bg-muted sticky top-0">
          <tr>
            {columns.map((c) => (
              <th key={c} className="text-left px-2 py-1 font-medium">
                {c}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {displayRows.map((r, i) => (
            <tr key={i} className="border-t">
              {columns.map((c) => (
                <td key={c} className="px-2 py-1 whitespace-nowrap">
                  {formatCell(r[c])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {rows.length > 100 && (
        <div className="px-2 py-1 text-xs text-muted-foreground">
          Showing 100 of {rows.length} rows.
        </div>
      )}
    </div>
  );
}
